import { render, staticRenderFns } from "./MediaExplorer.vue?vue&type=template&id=97c4f580&"
import script from "./MediaExplorer.vue?vue&type=script&lang=js&"
export * from "./MediaExplorer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports